import { forwardRef } from 'react';
import { convertSnakeCaseToReadable } from '../../../../utils/StringFormatters';
import { useDynamicEntityStoreContext } from '../../../contexts';

const InputWrapper = forwardRef((props, ref) => {
  const { allowSettings, name, description, label, className = 'd-flex flex-column gap-1', children } = props;

  const inputLabel = label || name;

  const update = useDynamicEntityStoreContext((state) => state.update);

  const handleSettingsOnClick = () => update({ activePane: 6, elementBeingEditedName: name });

  return (
    <div className={className} ref={ref}>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-muted fw-bold">{convertSnakeCaseToReadable(inputLabel)}</label>
        {allowSettings && (
          <button className="btn btn-sm btn-outline" onClick={handleSettingsOnClick}>
            <i className="fe fe-settings" />
          </button>
        )}
      </div>
      {children}
      {description && (
        <div>
          <label className="text-muted">{description}</label>
        </div>
      )}
    </div>
  );
});

export default InputWrapper;
